import React, { useEffect, useState } from 'react';
import Params from '../../../../../Types/ParamsPicklist';
import { Box, CircularProgress, Grid, TextField, Typography } from '@mui/material';
import { useAuthHeader, useAuthUser } from '../../../../../Services/Auth/sessionAuth';
import Utilisateur from '../../../../../Models/Utilisateur';
import SetMultipleDocument from '../../../../SetMultipleDocument';
import ReadOnlyDocumentList from '../../../../ReadOnlyDocumentList';




function Tab3 (props: { form?: any, documents?: any[] }) {
  // USER SESSION
  const auth = useAuthUser()
  const documents = props.documents || [];

  return (
    <div className='tabItem'>
        <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"}>
           <Grid container spacing={2} >
           <Grid item xs={12} md={12}  lg={12} >
                <ReadOnlyDocumentList documents={documents} loading={false} />
             </Grid>
            </Grid>
        </Box>
      
    </div>
  )
}

export default Tab3;  
